import axios from "axios";
import { api } from "./api";
import { useNavigate } from "react-router-dom";
import { AUTH_API_URL } from "../constants/urls";

//const authApiUrl = `https://${process.env.REACT_APP_ENV}-auth.${process.env.REACT_APP_URL_API}`;
//const userApiUrl = `https://${process.env.REACT_APP_ENV}-users.${process.env.REACT_APP_URL_API}`;

const authApiUrl = AUTH_API_URL;
const userApiUrl = `https://${process.env.REACT_APP_ENV}-users.${process.env.REACT_APP_URL_API}`;

export const refreshToken = async () => {
  const refreshToken = sessionStorage.getItem("refreshToken");

  if (!refreshToken) {
    console.log("No refresh token available");
    return null;
  }

  try {
    const response = await axios.post(`${authApiUrl}/api/auth/refresh`, {
      refreshToken,
    });

    if (response.status === 200) {
      const newAccessToken = response.data.accessToken;
      sessionStorage.setItem("token", newAccessToken); // Update access token
      return newAccessToken;
    }
  } catch (error) {
    console.log("Failed to refresh token", error);
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refreshToken");
    return null;
  }
};

export const apiUser = async (params: any = {}) => {
  try {
    //return await api.get(`${userApiUrl}/users`, params);
    return await api.post(`http://127.0.0.1:5555/users`, params);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response?.data;
    }
    return e;
  }
};

export const apiAuth = async (params: any = {}) => {
  axios
    .post(`${authApiUrl}/api/auth/login`, params)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => console.error(error));
};

export const apiGet = async (url: string, params: any = {}) => {
  try {
    //return await api.post(`${authApiUrl}/auth/login`, params);
    return await api.get(`${authApiUrl}${url}`, params);
  } catch (e: any) {
    debugger;
    if (axios.isAxiosError(e)) {
      return e.response;
    }
    return e;
  }
};

export const apiPost = async (url: string, params: any = {}) => {
  let response;
  try {
    const token = sessionStorage.getItem("token");
    response = await axios.post(`${authApiUrl}${url}`, params, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 401) {
        // Token might be expired, try refreshing
        const newToken = await refreshToken();

        if (newToken) {
          // Retry the request with the new token
          try {
            response = await axios.post(`${authApiUrl}${url}`, params, {
              headers: {
                Authorization: `Bearer ${newToken}`,
              },
            });
            return response;
          } catch (retryError: any) {
            return retryError.response;
          }
        } else {
          // If refresh failed, navigate to login or handle it appropriately
          return e.response;
        }
      }
      return e.response;
    }
    return e;
  }
};

export const apiPostWithFile = async (url: string, params: any = {}) => {
  try {
    //return await api.post(`${authApiUrl}/auth/login`, params);
    return await api.postWithFile(`${authApiUrl}${url}`, params);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response;
    }
    return e;
  }
};

export const apiDelete = async (url: string, params: any = {}) => {
  try {
    //return await api.post(`${authApiUrl}/auth/login`, params);
    return await api.delete(`${url}`, params);
  } catch (e: any) {
    if (axios.isAxiosError(e)) {
      return e.response?.data;
    }
    return e;
  }
};
